import React from 'react';
import Stack from '@mui/material/Stack';

import type { InterventionCenterGovStatistics as InterventionCenterGovStatisticsType } from '../../../common/types/statistics/fhbfStatistics';
import type { StatisticsFilter } from '../../../common/types/statistics/statistics';
import GovStatisticHeader from './GovStatisticHeader';
import InterventionCenter from './InterventionCenter';
import Case from './Case';
import Counseling from './Counseling';
import ReasonForTheConsultation from './ReasonForTheConsultation';
import RelationshipToThePerpetrator from './RelationshipToThePerpetrator';
import ReferralAndRecommendation from './ReferralAndRecommendation';
import NumberOfPersonalAccompaniment from './NumberOfPersonalAccompaniment';
import CaseIndependentCooperationWithThePolice from './CaseIndependentCooperationWithThePolice';
import Networking from './Networking';

type Props = {
  statistics: InterventionCenterGovStatisticsType;
  statisticFilter: StatisticsFilter;
};

function InterventionCenterGovStatistics({ statistics, statisticFilter }: Props) {
  return (
    <Stack sx={{ display: 'block' }}>
      <GovStatisticHeader statisticFilter={statisticFilter} />
      <InterventionCenter />
      <Case statistics={statistics} />
      <Counseling statistics={statistics} />
      <ReasonForTheConsultation statistics={statistics} />
      <RelationshipToThePerpetrator statistics={statistics} />
      <ReferralAndRecommendation statistics={statistics} />
      <NumberOfPersonalAccompaniment statistics={statistics} />
      <CaseIndependentCooperationWithThePolice />
      <Networking />
    </Stack>
  );
}

export default InterventionCenterGovStatistics;
